module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_53.71702ce1.png";